// base64 ⇄ base64url: `+/` become `-_`, trailing `=` padding is stripped
const BASE64_PLUS = /\+/g
const BASE64_SLASH = /\//g
const BASE64_PADDING = /=+$/
const BASE64URL_DASH = /-/g
const BASE64URL_UNDERSCORE = /_/g

/** Encode raw bytes as URL/query-param-safe base64url (no padding). */
export function bytesToBase64Url(bytes: Uint8Array): string {
	let binary = ''
	for (const byte of bytes) binary += String.fromCharCode(byte)
	return btoa(binary)
		.replace(BASE64_PLUS, '-')
		.replace(BASE64_SLASH, '_')
		.replace(BASE64_PADDING, '')
}

/** Decode a base64url string produced by {@link bytesToBase64Url} back to bytes. */
export function base64UrlToBytes(encoded: string): Uint8Array {
	const binary = atob(encoded.replace(BASE64URL_DASH, '+').replace(BASE64URL_UNDERSCORE, '/'))
	return Uint8Array.from(binary, (char) => char.charCodeAt(0))
}

/** base64url-encode any JSON-serialisable value — URL/query-param safe. */
export function encodeJsonBase64Url<T>(value: T): string {
	return bytesToBase64Url(new TextEncoder().encode(JSON.stringify(value)))
}

/**
 * decode a base64url-encoded JSON value produced by {@link encodeJsonBase64Url}.
 * returns null on malformed input instead of throwing.
 */
export function decodeJsonBase64Url<T>(encoded: string): T | null {
	try {
		return JSON.parse(new TextDecoder().decode(base64UrlToBytes(encoded))) as T
	} catch {
		return null
	}
}
